// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Category, CategoryCollection } from "@insite/client-framework/Services/CategoryService";
import { Draft } from "immer";

interface PromotionTreeState {
    categories?: Category[];
}
const initialState: PromotionTreeState = {};

const actions = {
    "Pages/PromotionTree/LoadPromotionTree": (draft: Draft<PromotionTreeState>, action: { categories: Category[] }) => {
        draft.categories = action.categories;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type PromotionTreeActions = Parameters<typeof reducer>[1];
export default reducer;
